import { useEffect, useState } from 'react';

export const useExternalNavigate = (
  externalUrl: string,
  target: '_blank' | '_self' = '_self'
) => {
  const [executeNavigation, setExecuteNavigation] = useState(false);

  const navigate = () => setExecuteNavigation(true);

  useEffect(() => {
    if (executeNavigation) {
      window.open(externalUrl, target);
    }
  }, [executeNavigation]);

  return {
    navigate: navigate,
  };
};
